export const isPhoneNumberValid = (phonenumber) => {
  return /^\d+$/.test(phonenumber) && phonenumber.length === 10;
}